import type { TranslationTag } from '@ps/web-core-intl';

import {
  TXTCLI_1st_3,
  TXTCLI_2nd_1,
  TXTCLI_3rd_1,
  TXTCLI_4TH,
  TXTCLI_5TH,
  TXTCLI_6TH,
  TXTCLI_7TH,
  TXTCLI_8TH
} from './prizeData.messages.json';

type PrizeClassName = 'gamePrizeGold' | 'gamePrizeSilver' | 'gamePrizeBronze' | 'gamePrizePlace';

export const PRIZE_TRANSLATIONS: {
  key: PrizeClassName;
  translation: TranslationTag;
}[] = [
  {
    key: 'gamePrizeGold',
    translation: TXTCLI_1st_3
  },
  {
    key: 'gamePrizeSilver',
    translation: TXTCLI_2nd_1
  },
  {
    key: 'gamePrizeBronze',
    translation: TXTCLI_3rd_1
  },
  {
    key: 'gamePrizePlace',
    translation: TXTCLI_4TH
  },
  {
    key: 'gamePrizePlace',
    translation: TXTCLI_5TH
  },
  {
    key: 'gamePrizePlace',
    translation: TXTCLI_6TH
  },
  {
    key: 'gamePrizePlace',
    translation: TXTCLI_7TH
  },
  {
    key: 'gamePrizePlace',
    translation: TXTCLI_8TH
  }
];
